import { FirstStepsState } from '../../../../@types';

const initialState: FirstStepsState = {
  address: {
    streetName: '',
    streetNumber: '',
    postalCode: '',
    city: '',
    country: '',
  },
  referralCode: '',
  phone: {
    phoneNumber: '',
    phoneCode: {
      country: 'DE',
      code: '+49',
    },
  },
  phoneCodes: [],
  circleCode: '',
  dateOfBirth: '',
  iban: '',
  bic: '',
  isVerifyingGDPREmail: false,
  isEditingPhone: false,
  showExternalBrowserScreen: false,
  billingInfo: null,
};
export default initialState;
